module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-supplier"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('h4', [_vm._v("合作供应商")]), _vm._v(" "), _c('hr', {
    attrs: {
      "id": "supplier-hr1"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "id": "supplier-hr2"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "supplier"
    }
  }, [_c('table', [_c('tbody', [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "supplier-carousel-generic",
      "data-interval": "3000",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators hidden"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#supplier-carousel-generic",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#supplier-carousel-generic",
      "data-slide-to": "1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox",
      "id": "supplier-roll"
    }
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('tr', [_c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/zhongmei.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/zhenengdianli.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "id": "img-width",
      "src": "static/imgs/SKF.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/coalgroup.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/baogang.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/tongling.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('tr', [_c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/wanfangdian.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/xinyu.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": "static/imgs/FAG.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/shenhua.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/juhua.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "partners-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/jiangxitongye.png",
      "alt": ""
    }
  })])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d08822b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-supplier.vue
// module id = 38
// module chunks = 4 5 6 7 8 9 10 11 12 13